'use strict';

var blockSearch = blockSearch || {};
var $ = jQuery;

/* INIT
 ----------------------------------------------------------------------------------------------------------------------*/
blockSearch.init = function () {
  blockSearch.isActive();
}

/* DOM READY
 ----------------------------------------------------------------------------------------------------------------------*/
$(blockSearch.init);

/* FUNCTIONS
 ----------------------------------------------------------------------------------------------------------------------*/
blockSearch.isActive = function () {

  // console.log('blockSearch');

  var button = $('.search-toggler');
  var searchbar = $('#searchBar');

  searchbar.on('show.bs.collapse', function() {
    button.addClass('is-active');
    $( "<span class='overlay'></span>" ).insertBefore("#searchBar");
  });

  searchbar.on('hide.bs.collapse', function() {
    button.removeClass('is-active');
    $(".overlay").remove();
  });

  $('button').click( function(e) {
    $('.collapse').collapse('hide');
  });

};